export const FETCH_LOOKALIKE_PRODUCTS = "FETCH_LOOKALIKE_PRODUCTS";
export const FETCH_LOOKALIKE_PRODUCTS_SUCCESS = "FETCH_LOOKALIKE_PRODUCTS_SUCCESS";
